module.exports = __webpack_public_path__ + "img/popup-btn.8025ea17.png";